/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  
// Product-card swatches: tap/click swaps the image instead of opening the product
var FJ_SEL = '.product-item__swatches__holder .swatch__link';
function fjShow(item, name) { var wrap = item.querySelector('[data-product-image]'); if (!wrap) return; var match = null; wrap.querySelectorAll('[data-variant-title]').forEach(function (el) { el.classList.remove('is-visible'); if (el.getAttribute('data-variant-title') === name) match = el; }); if (match) match.classList.add('is-visible'); }
function fjPick(e) { var link = e.target.closest ? e.target.closest(FJ_SEL) : null; if (!link) return; e.preventDefault(); e.stopPropagation(); var btn = link.closest('[data-swatch-button]'); var item = link.closest('[data-grid-item]'); var holder = link.closest('.product-item__swatches__holder'); if (!btn || !item) return; item.querySelectorAll('[data-swatch-button]').forEach(function (b) { b.classList.remove('is-selected'); }); btn.classList.add('is-selected'); if (holder) holder.classList.add('has-selection'); var name = btn.getAttribute('data-swatch-variant-name') || ''; item.setAttribute('data-selected-variant-title', name); fjShow(item, name); var href = link.getAttribute('href'); if (href) item.querySelectorAll('a.product-link').forEach(function (a) { a.setAttribute('href', href); }); }
function fjRestore(e) { var item = e.target.closest ? e.target.closest('[data-grid-item]') : null; if (!item) return; if (e.relatedTarget && item.contains(e.relatedTarget)) return; var name = item.getAttribute('data-selected-variant-title'); if (name) setTimeout(function () { fjShow(item, name); }, 0); }
document.addEventListener('click', fjPick, true);
document.addEventListener('mouseout', fjRestore, true);



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
